import React from 'react';
import { FIELD_NAMES } from './BillingAddress.schema';
import { billingAddress as TEXT } from 'locales/en/cart';
import PropType from 'prop-types';

export const MinimizedBillingAddress = ({ form, onClickChange }) => {
  return (
    <>
      <div
        data-testid="billing-address"
        className="lg:border lg:mb-0 mb-4 border-javelin-inputBorder lg:rounded grid grid-cols-3 lg:-mt-10 lg:flex lg:justify-between lg:p-5 lg:items-center items-start"
      >
        <div className="col-span-2 lg:flex lg:items-center lg:w-10/12">
          <h2
            data-testid="title"
            className="text-javelin-gray-dark text-sm lg:text-xs lg:text-opacity-40 lg:w-36"
          >
            {TEXT.title_shipping}
          </h2>
          <div
            data-testid="details"
            className="lg:flex lg:flex-row lg:w-9/12 overflow-ellipsis whitespace-nowrap overflow-hidden"
          >
            <p className="text-sm text-javelin-gray-dark text-opacity-30 lg:text-opacity-100">
              {form[FIELD_NAMES.name]} &nbsp; {form[FIELD_NAMES.address_1]}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="text-sm text-javelin-blue-dark border-0 focus:outline-none text-right"
          onClick={onClickChange}
        >
          Change
        </button>
      </div>
      <hr className="horizontal-line w-screen -mx-3 lg:hidden" />
    </>
  )
}

MinimizedBillingAddress.propTypes = {
  form: PropType.object
}
